import { useEffect, useRef } from "react";
import { NavigationType, useLocation, useNavigationType } from "react-router";

import { trackSegmentEvent } from "shared/Analytics";

// Semi-internal @remix-run/router entry index; comparing it across a Pop
// navigation tells the traversal direction (smaller = backward)
const getBrowserHistoryIndex = () => {
  const index: unknown = window.history.state?.idx;
  return typeof index === "number" ? index : undefined;
};

const useAnalyticsBrowserBackTracking = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const lastHistoryIndexRef = useRef(getBrowserHistoryIndex());
  const previousPathnameRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const historyIndex = getBrowserHistoryIndex();
    // Also false on the initial location (it reports NavigationType.Pop too) and on
    // StrictMode's double-invoked effects — the index hasn't moved in those cases
    const isBackwardNavigation =
      historyIndex !== undefined &&
      lastHistoryIndexRef.current !== undefined &&
      historyIndex < lastHistoryIndexRef.current;

    if (navigationType === NavigationType.Pop && isBackwardNavigation) {
      trackSegmentEvent("Browser back used", {
        fromPathname: previousPathnameRef.current,
        toPathname: location.pathname,
      });
    }

    lastHistoryIndexRef.current = historyIndex;
    previousPathnameRef.current = location.pathname;
  }, [location, navigationType]);
};

export default useAnalyticsBrowserBackTracking;
